import type { SxProps, Theme } from "@mui/material/styles";

const ACCENT = "#7B49C1";

export const getPopperSx = (): SxProps<Theme> => ({
  zIndex: 1400,
  width: "min(100vw - 24px, 420px)",
});

export const getPaperSx = (
  isDarkMode: boolean,
  width?: number,
): SxProps<Theme> => ({
  backgroundColor: isDarkMode ? "#1F2130" : "#FFFFFF",
  borderRadius: "14px",
  overflow: "hidden",
  border: isDarkMode
    ? "1px solid rgba(255, 255, 255, 0.1)"
    : "1px solid rgba(15, 23, 42, 0.08)",
  boxShadow: isDarkMode
    ? "0 16px 48px rgba(0,0,0,0.5)"
    : "0 8px 28px rgba(15, 23, 42, 0.16)",
  ...(width ? { width } : {}),
});

export const listSx: SxProps<Theme> = {
  maxHeight: 260,
  overflowY: "auto",
  py: 0.5,
};

export const getRowSx = (
  isDarkMode: boolean,
  selected: boolean,
): SxProps<Theme> => ({
  display: "flex",
  alignItems: "flex-start",
  gap: 1.25,
  px: 1.5,
  py: 1,
  cursor: "pointer",
  backgroundColor: selected
    ? isDarkMode
      ? "rgba(196, 181, 253, 0.12)"
      : "rgba(123, 73, 193, 0.08)"
    : "transparent",
  "&:hover": {
    backgroundColor: isDarkMode
      ? "rgba(196, 181, 253, 0.16)"
      : "rgba(123, 73, 193, 0.1)",
  },
});

export const avatarSx: SxProps<Theme> = {
  width: 36,
  height: 36,
  borderRadius: "50%",
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: ACCENT,
  color: "#FFFFFF",
  mt: "2px",
};

export const getLabelSx = (isDarkMode: boolean): SxProps<Theme> => ({
  fontFamily: "Red Hat Display",
  fontWeight: 700,
  fontSize: 14,
  lineHeight: 1.3,
  color: isDarkMode ? "#F3F4F6" : "#111827",
});

export const getDetailSx = (isDarkMode: boolean): SxProps<Theme> => ({
  fontFamily: "Red Hat Display",
  fontWeight: 500,
  fontSize: 12,
  lineHeight: 1.35,
  color: isDarkMode ? "#9CA3AF" : "#6B7280",
  mt: 0.15,
});

export const getOwnerSx = (isDarkMode: boolean): SxProps<Theme> => ({
  fontFamily: "Red Hat Display",
  fontWeight: 500,
  fontSize: 11,
  color: isDarkMode ? "#C4B5FD" : ACCENT,
  mt: 0.15,
});

export const duplicateSx: SxProps<Theme> = {
  fontFamily: "Red Hat Display",
  fontWeight: 600,
  fontSize: 11,
  color: "#B45309",
  mt: 0.2,
};

export const getHintSx = (isDarkMode: boolean): SxProps<Theme> => ({
  px: 1.5,
  py: 1.25,
  fontFamily: "Red Hat Display",
  fontWeight: 500,
  fontSize: 13,
  color: isDarkMode ? "#9CA3AF" : "#6B7280",
});
